import {Grid , Typography  , Button , Box} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import '../App.css';

function HireMe(){
    return(
        
       <Box  style={{backgroundColor : '#2f3237' , marginTop : '3em'}} >
            <Grid container rowSpacing={1} >
                <Grid item xs={12} textAlign='center' marginTop ='2em'>
                    <Typography component='h2' color='white' style={{fontSize : '40px'}}>I'm currently available for freelance work</Typography>
                </Grid>
                <Grid item xs={12} textAlign='center' marginTop ='2em' marginBottom='2em'>
                    <Button 
                        variant='outlined' 
                        color = 'inherit'
                        sx={{
                            color : 'white', 
                            borderColor : 'white' , 
                            opacity  : '0.5' , 
                            '&:hover' : {opacity : 1} 
                        }}  
                        onClick={()=>window.open("//www.freelancer.com/u/nadirmes",'_blank')}
                        startIcon={<CheckIcon />}
                    >
                        Hire Me
                    </Button>
                </Grid>
            </Grid>
       </Box>
    )
}

export default HireMe;